import CompetitorsReport from "@/views/Agencies/CompetitorsReport.vue";
import CustomReport from "@/views/Agencies/CustomReport.vue";

import Agencies from "@/views/Agencies.vue";
import {
  FEATURE_AGENCIES_COMPETITORS,
  FEATURE_AGENCIES_REPORT,
} from "@/constants";

const routes = [
  {
    path: "/agencies",
    component: Agencies,
    children: [
      {
        path: "competitors-report",
        component: CompetitorsReport,
        name: "competitor-report",
        meta: {
          allowAgencies: true,
          feature: FEATURE_AGENCIES_COMPETITORS,
        },
      },
      {
        path: "custom-report",
        component: CustomReport,
        name: "custom-report",
        meta: {
          allowAgencies: true,
          feature: FEATURE_AGENCIES_REPORT,
        },
      },
    ],
  },
];

export default routes;
